import React, { useState, useEffect, useRef } from "react";
import { JSONEditor } from "vanilla-jsoneditor";
import "./JsonViewer.css";

const JsonViewer = ({ content, handleUpdate }) => {
  const refContainer = useRef(null);
  const refEditor = useRef(null);

  const [data, setData] = useState(content);

  const customRenderMenu = (items, context) => {
    return items.filter((item) => {
      if (
        item.type === "button" &&
        (item.text === "text" || item.text === "table" || item.text === "tree")
      ) {
        return false;
      }

      if (
        item.type === "button" &&
        (item.title === "Transform contents (filter, sort, project)" ||
          item.title === "Undo (Ctrl+Z)" ||
          item.title === "Redo (Ctrl+Shift+Z)" ||
          item.title === "Sort")
      ) {
        return false;
      }

      return true;
    });
  };

  useEffect(() => {
    setData(content);
  }, [content]);

  function handleChange(json) {
    const web_url = data.web_url;
    const startup_applications = data.startup_applications;
    const constructedObj = { ...json, web_url, startup_applications };

    handleUpdate(constructedObj);
    setData(constructedObj);
  }

  useEffect(() => {
    const { web_url, startup_applications, ...newObj } = data;

    refEditor.current = new JSONEditor({
      target: refContainer.current,
      props: {
        content: { json: newObj },
        onChange: (updatedJson) => {
          if (handleUpdate) {
            handleChange(updatedJson.json);
          }
        },
        onRenderMenu: customRenderMenu,
      },
    });

    return () => {
      if (refEditor.current) {
        refEditor.current.destroy();
        refEditor.current = null;
      }
    };
  }, [data]);

  return <div ref={refContainer} />;
};

export default JsonViewer;
